<template>
  <div class="d-flex gap-1 row inmap top left">
    <div class="geogrid-info" :class="{ 'selected-competitor': competitorIndex !== -1 }">
      <div class="label">Ranked business:</div>
      <div class="data">{{ geogrid.attrs.businessName }}</div>
    </div>

    <div class="geogrid-info">
      <div class="label">Search term:</div>
      <div class="data">{{ geogrid.searchTerm }}</div>
    </div>

    <div class="geogrid-info" :class="{ 'selected-competitor': competitorIndex !== -1 }">
      <div class="d-flex gap-2 align-items-center">
        <div>
          <div class="label">Competitors:</div>
          <div class="data">{{ geogrid.competitors.length }}</div>
        </div>
        <a href="#" @click.prevent="toggleCompetitors">
          <i class="fa-solid fa-chevron-down" :class="{ 'fa-rotate-180': isCompetitorsShown }" />
        </a>
      </div>
    </div>

    <button
      v-if="competitorIndex !== -1"
      type="button"
      class="btn btn-primary btn-sm gap-2"
      @click="selectCompetitor(competitorIndex)">
      <i class="fa-solid fa-chevron-left font-size-12" />
      <span class="font-size-12">Back to my geogrid</span>
    </button>

    <div v-if="isCompetitorsShown" class="geogrid-competitors-info scroll ver">
      <GeogridCompetitor
        v-for="(competitor, index) in geogrid.competitors"
        :key="index"
        :competitor="competitor"
        :class="['geogrids-widget-panel__competitor', { selected: index === competitorIndex }]"
        @click.native="selectCompetitor(index)">
        <template #rank>
          {{ index + 1 }}
        </template>
      </GeogridCompetitor>
    </div>
  </div>
</template>

<script>
import GeogridCompetitor from './geogrid_competitor'

export default {
  components: {
    GeogridCompetitor
  },
  props: {
    geogrid: { type: Object, required: true }
  },
  data() {
    return {
      isCompetitorsShown: false,
      competitorIndex: -1
    }
  },
  methods: {
    toggleCompetitors() {
      this.isCompetitorsShown = !this.isCompetitorsShown
    },
    selectCompetitor(competitorIndex) {
      if (this.competitorIndex === competitorIndex) {
        this.competitorIndex = -1
      } else {
        this.competitorIndex = competitorIndex
      }
      this.$emit('selectCompetitor', this.competitorIndex)
    }
  }
}
</script>
